const ROADMAP = [
  // ━━━ DÉJÀ FAIT ━━━
  {
    id: "founding",
    period: "Automne 2025",
    title: "Genèse du projet",
    status: "done",
    description: "Premiers prototypes, validation du concept auprès de RH et Office Managers. Décision d'un format full-digital pour briser la barrière logistique.",
    highlights: [
      "Recherche utilisateurs auprès de 30+ entreprises",
      "Premier prototype testé en interne",
    ],
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=800&q=80",
    color: "slate",
  },
  {
    id: "alpha",
    period: "Hiver 2025",
    title: "Alpha & beta privée",
    status: "done",
    description: "Premières équipes invitées en bêta privée. Itérations massives sur la mécanique de coopération à 4-6 joueurs et sur l'expérience d'onboarding.",
    highlights: [
      "+10 groupes bêta-testeurs",
      "Affinement de la formule pricing B2B",
    ],
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=800&q=80",
    color: "slate",
  },
  {
    id: "launch",
    period: "Avril 2026",
    title: "Lancement public",
    status: "done",
    description: "Mise en ligne de blackout-games.fr et lancement commercial du premier escape game digital « Projet Origami ». Plateforme de paiement Stripe en LIVE.",
    highlights: [
      "Projet Origami disponible en pack à partir de 145€ HT/session",
      "Programme partenaires lancé en parallèle",
    ],
    image: "https://images.unsplash.com/photo-1636819488524-1f019c4e1c44?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    color: "indigo",
  },

  // ━━━ EN COURS ━━━
  {
    id: "seminaire",
    period: "Été 2026",
    title: "Jeu 2 - Séminaire en détresse",
    status: "in_progress",
    description: "Une comédie absurde où votre équipe doit sauver un séminaire d'entreprise qui part en vrille. Un ton complètement différent du Projet Origami, plus accessible, plus drôle, parfait pour les premières découvertes du format.",
    highlights: [
      "Difficulté Facile (parfait pour les débutants)",
      "60 minutes, 3-5 joueurs",
      "Décisions narratives qui influencent la suite du jeu",
    ],
    image: "/assets/mulhouseCatalogue.png",
    color: "orange",
  },
  {
    id: "partenaires",
    period: "Été–Automne 2026",
    title: "Réseau de partenaires",
    status: "in_progress",
    description: "Déploiement du programme d'affiliation auprès des escape rooms physiques et boutiques de jeux de société partout en France. Notre objectif : 30 partenaires actifs d'ici fin 2026.",
    highlights: [
      "Commission 10% sur la première commande référée",
      "Kit partenaire complet (cartes, espace de suivi)",
      "Espace partenaire avec stats temps réel",
    ],
    image: "https://plus.unsplash.com/premium_photo-1770566424146-6c100007410f?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    color: "orange",
  },

  // ━━━ À VENIR ━━━
  {
    id: "jeu3",
    period: "Hiver 2026",
    title: "Jeu 3 - En préparation",
    status: "upcoming",
    description: "Un nouvel univers, une nouvelle équipe d'illustrateurs, de nouvelles mécaniques de jeu. On prépare quelque chose de très différent des deux premiers jeux. Plus d'infos très bientôt.",
    highlights: [
      "Nouvelle direction artistique",
      "Difficulté Intermédiaire à Avancé",
    ],
    image: "https://images.unsplash.com/photo-1512375305577-4dc349fcef0b?q=80&w=1461&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    color: "indigo",
  },
  {
    id: "international",
    period: "Printemps–Été 2027",
    title: "Version anglaise & expansion",
    status: "upcoming",
    description: "Traduction complète de la plateforme et des jeux en anglais, ouverture aux marchés européens et internationaux. Ouverture à des partenaires hors France.",
    highlights: [
      "Plateforme bilingue FR/EN",
      "Ouverture marchés européens",
      "Partenaires internationaux",
    ],
    image: "https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?auto=format&fit=crop&w=800&q=80",
    color: "purple",
  },
  {
    id: "catalogue",
    period: "2027+",
    title: "Catalogue étoffé",
    status: "upcoming",
    description: "Au-delà des trois premiers jeux, un catalogue régulièrement enrichi avec de nouveaux univers, mécaniques et difficultés. L'objectif : que chaque équipe trouve l'expérience qui lui ressemble.",
    highlights: [
      "Nouveaux jeux toutes les 12-16 semaines",
      "Univers variés : enquête, survival, comédie, mystère",
      "Tous niveaux de difficulté",
    ],
    image: "https://plus.unsplash.com/premium_photo-1671384378697-07cda21eafaf?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    color: "purple",
  },
];

export default ROADMAP;

// Helpers
export const getUpcomingMilestones = (count = 3) => {
  const inProgress = ROADMAP.filter(m => m.status === "in_progress");
  const upcoming = ROADMAP.filter(m => m.status === "upcoming");
  return [...inProgress, ...upcoming].slice(0, count);
};

export const getRoadmapStats = () => ({
  done: ROADMAP.filter(m => m.status === "done").length,
  inProgress: ROADMAP.filter(m => m.status === "in_progress").length,
  upcoming: ROADMAP.filter(m => m.status === "upcoming").length,
  total: ROADMAP.length,
});